import React from "react";
import { Routes, Route } from "react-router-dom";
import { Layout } from "./Layout";
import Home from "./pages/Home";
import ChiSiamo from "./pages/ChiSiamo";
import Prodotti from "./pages/Prodotti";
import ProductDetail from "./pages/ProductDetail";
import Contatti from "./pages/Contatti";
import LavoraConNoi from "./pages/LavoraConNoi";
import Privacy from "./pages/Privacy";
import NotFound from "./pages/NotFound";

export const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Layout />}>
      <Route index element={<Home />} />
      <Route path="chi-siamo" element={<ChiSiamo />} />
      <Route path="prodotti" element={<Prodotti />} />
      <Route path="prodotti/:slug" element={<ProductDetail />} />
      <Route path="contatti" element={<Contatti />} />
      <Route path="lavora-con-noi" element={<LavoraConNoi />} />
      <Route path="privacy" element={<Privacy />} />
      <Route path="*" element={<NotFound />} />
    </Route>
  </Routes>
);
